import script from "./ViewProvide.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewProvide.vue?vue&type=script&setup=true&lang=js"

import "./ViewProvide.vue?vue&type=style&index=0&id=306a6a2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-306a6a2c"]])

export default __exports__